export default "__VITE_ASSET__B109AWQm__"